import { getEnabledItems, splitNavigationItems } from './utils';
import { NavigationLinksProps } from './interface';
import MainNavigationItems from './MainNavigationItems';
import MoreNavigationItem from './MoreNavigationItem';

const NavigationLinks = (props: NavigationLinksProps) => {
  const { items, featureFlags, roles, pathname, search, linkClickHandler } = props;

  const visibleNavigationItems = getEnabledItems(items, featureFlags, roles);

  const { primaryNavItems, secondaryNavItems } = splitNavigationItems(visibleNavigationItems);

  return (
    <>
      <MainNavigationItems
        items={primaryNavItems}
        pathname={pathname}
        search={search}
        linkClickHandler={linkClickHandler}
      />
      {secondaryNavItems.length > 0 ? (
        <MoreNavigationItem
          items={secondaryNavItems}
          pathname={pathname}
          search={search}
          linkClickHandler={linkClickHandler}
        />
      ) : null}
    </>
  );
};

export default NavigationLinks;
